import {useEffect, useLayoutEffect} from "react";
import {getBranding} from "../redux/branding/branding.actions";
import {useAppDispatch} from "../redux/store";
import {useSnackbar} from "notistack";
import {useLocation} from "react-router";
import WebFont from "webfontloader";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

export const useBranding = () => {
    const query = useQuery();
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    useLayoutEffect(() => {
        (async () => {
            const partnerId = query.get("partnerId");
            if (partnerId) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
                await dispatch(getBranding(partnerId)).then((res) => WebFont.load({
                    google: {
                        families: [res.font?.header, res.font?.text]
                    }
                }))
                    .catch(err =>
                        enqueueSnackbar("Can not find partner by given id", {
                            variant: "error",
                            autoHideDuration: 3000
                        })
                    );
            }
        })();
    }, []);
};
